import React, { useEffect, useReducer } from "react";
import TimeTable from "./components/timeTable";
import TimeTableTeacher from "./components/timeTableTeacher";


import Changes from "./components/Changes";
import Nav from "./components/parts/Nav";
import MenuButton from "./components/MenuButton";
import ChangesTable from "./components/ChangesTable";
import toast from 'react-simple-toasts';

import { BrowserRouter as Router, Route } from "react-router-dom";
import {
  getWeekDates,
  getTodayDate,
  changeDateFormat,
  getTodayDateWebview,
} from "./helpers/TimeTableHelpers";
// context import
import TimeTableContext from "./context/timeTableContext";
// reducers import
import { initialState, timeTableReducer } from "./reducers/timeTableReducers";

import "bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css";
import "./App.css";
import { getHighestHour } from "./helpers/TimeTableHelpers";
import WeeklyTime from "./components/weeklyTime/WeeklyTime";
import DistanceLearning from "./components/distanceLearning/distanceLearning";
import BarcodeReader from "./components/barcodeReader/barcodeReader";

function App() {
  // create reducer
  const [state, dispatch] = useReducer(timeTableReducer, initialState);

  const currentUrl = new URL(window.location);
  const currentSchool = currentUrl.searchParams.get("id");
  const currentScreen = currentUrl.searchParams.get("screen")
    ? parseInt(currentUrl.searchParams.get("screen"))
    : 1;
  const teacherId = currentUrl.searchParams.get("teacherId");

  const currentClass = currentUrl.searchParams.get("classId");

  let dateObj = new Date();
  let todayDay = dateObj.getDay();

  const debug = currentUrl.searchParams.get("debug");
  const API = `https://${debug ? "dev" : "my"}.schooly.co.il/tt/insti_code`;
  let countTriesToLoadData = 0;
  // run effect to get info once
  useEffect(() => {
    //console.log(currentScreen)

    dispatch({ type: "SET_DEBUG", payload: debug });
    dispatch({ type: "SET_CURRENT_SCHOOL", payload: currentSchool });
    dispatch({ type: "SET_TEACHER_ID", payload: teacherId });
    dispatch({ type: "SET_CURRENT_SCREEN", payload: currentScreen });
    if (currentSchool) {
      getTimeTableInfo(currentSchool, getTodayDate(), true);
    }
  }, [currentSchool, currentScreen]);

  const getTimeTableInfo = async (id, date, setClass = false) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      console.log(`${API}/${id}?startDate=${date}`)
      const jsonInfo = await fetch(`${API}/${id}?startDate=${date}`);
      const contentType = jsonInfo.headers.get("content-type");
      // console.log(`${API}/${id}?startDate=${date}`);
      // const jsonInfo = await fetch(`http://localhost/dev/json.php`)
      console.log(contentType);
      if (contentType && contentType.indexOf("text/json; charset:utf8") !== -1) {
        const objInfo = await jsonInfo.json();

        let todayDate = changeDateFormat(objInfo.startDate);
        let highestHour = getHighestHour(objInfo.ttGroups);
        dispatch({ type: "SET_CURRENT_DAY", payload: todayDay });
        //dispatch({ type: 'SET_CURRENT_DATE', payload: moment() })

        dispatch({
          type: "SET_CURRENT_WEEK_FIRST_DAY",
          payload: objInfo.startDate,
        });
        dispatch({ type: "SET_CURRENT_WEEK", payload: getWeekDates(todayDate) });
        if (setClass) {
          dispatch({ type: "SET_CLASS", payload: objInfo.classes[0]._id });
        }

        dispatch({ type: "GET_INFO", payload: objInfo });

        if (currentClass) {
          var currentClassId = objInfo.classes.filter(curClass => curClass.id == currentClass);
          if (currentClassId.length) {
            dispatch({ type: "SET_CLASS", payload: currentClassId[0]._id });
          }
        }

        dispatch({ type: "SET_HIGH_HOUR", payload: highestHour });
        dispatch({
          type: "SET_CURRENT_TIME",
          payload: { day: 0, slot: 0 },
        });
        dispatch({ type: "SET_LOADING", payload: false });

      } else if (contentType && contentType.indexOf("application/text") !== -1 && countTriesToLoadData < 5) {
        setTimeout(function () {
          getTimeTableInfo(currentSchool, getTodayDate(), true);
          countTriesToLoadData++;
        }, 3000);

      } else {
        toast("אירעה שגיאה, נסה שנית מאוחר יותר", 3000);
      }
    } catch (e) {
      dispatch({ type: "SET_LOADING", payload: false });
      toast("אירעה שגיאה, נסה שנית מאוחר יותר", 3000);
    }



  };

  return (
    <TimeTableContext.Provider value={{ state, dispatch, getTimeTableInfo }}>
      {state.currentScreen != 6 &&
        state.currentScreen != 7 &&
        state.currentScreen != 8 && <Nav />}
      {state.currentScreen != 6 &&
        state.currentScreen != 7 &&
        state.currentScreen != 8 && <MenuButton />}

      {(state.currentScreen === 1 || state.currentScreen === 2) && (
        <TimeTable />
      )}
      {state.currentScreen === 3 && <Changes />}
      {(state.currentScreen === 4 || state.currentScreen === 5) && (
        <ChangesTable />
      )}
      {state.currentScreen === 6 && <WeeklyTime />}
      {state.currentScreen === 7 && <DistanceLearning />}
      {state.currentScreen === 8 && <BarcodeReader />}
      {state.currentScreen === 9 && <TimeTableTeacher />}

    </TimeTableContext.Provider>
  );
}

export default App;
